/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import AddressHelper from '../Helper/AddressHelper';
import { getFeatureFlags } from '../../../utils/featureSelectors';
import { isEmpty } from '../../../utils/object';

class ShippingAddress extends React.Component {
    modifyOrders = () => {
        const { openMmo, itemDetailList, orderData } = this.props;
        openMmo('editAddress', itemDetailList, orderData);
    };

    render() {
        const { recipient, isPassport, featureFlags } = this.props;
        // console.log(this.props);
        const ENABLE_MMO = !isEmpty(featureFlags)
            && featureFlags['is-account-mmo-enabled'] === true;
        return (
            <>
                <h2 className="gray-color no-margin-top">
                    {isPassport ? (
                        'Recipient'
                    ) : (
                        <>
                            <div className="split align-center">
                                <div className="align-left">
                                    Shipping Address
                                </div>
                                {recipient.recipientEnable === 'true' && ENABLE_MMO ? (
                                    <Button
                                        className="buttonBlue flex-none min-width-100"
                                        onClick={() => this.modifyOrders()}
                                    >
                                        Modify
                                    </Button>
                                ) : (
                                    ''
                                )}
                            </div>
                        </>
                    )}
                </h2>
                <div className="margin-bottom">
                    <div className="bold">
                        {recipient
                            ? `${recipient.firstName} ${recipient.lastName}`
                            : ''}
                    </div>
                    {recipient && recipient.businessName && !isPassport ? (
                        <div>{recipient.businessName}</div>
                    ) : (
                        ''
                    )}
                    {recipient && recipient.address && !isPassport ? (
                        <AddressHelper
                            address={recipient.address}
                            phone={recipient.phone || {}}
                        />
                    ) : (
                        ''
                    )}
                </div>
            </>
        );
    }
}

ShippingAddress.defaultProps = {
    isPassport: false,
    featureFlags: {},
};

ShippingAddress.propTypes = {
    recipient: PropTypes.object.isRequired,
    isPassport: PropTypes.bool,
    featureFlags: PropTypes.object,
    itemDetailList: PropTypes.array.isRequired,
    orderData: PropTypes.object.isRequired,
    openMmo: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    let featureFlags = {};
    if (state.app) {
        try {
            featureFlags = {
                ...getFeatureFlags(state),
            };
            // eslint-disable-next-line no-empty
        } catch (ex) { }
    }
    return {
        featureFlags,
    };
};

export default connect(
    mapStateToProps,
    null,
)(ShippingAddress);
